export default "__VITE_ASSET__BNK2ooWz__"